import colors from '../../assets/colors'

export default theme => ({
  '@keyframes circle': {
    from: {
      transform: 'rotate(360deg)',
    },
    to: {
      transform: 'rotate(0deg)',
    },
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
  fadeIn: {
    animation: '$fadeIn 1s ease-in-out',
  },
  pageHead: {
    marginBottom: 8,
  },
  root: {
    width: '100%',
    marginBottom: 20,
  },
  grow: {
    flex: 1,
  },
  gridContainer: {
    width: '100%',
  },
  btnIcon: {
    marginRight: theme.spacing(1),
  },
  content: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    // minHeight: '70vh',
  },
  btnMore: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  appBar: {
    position: 'relative',
    backgroundColor: colors.primary,
  },
  flex: {
    flex: 1,
  },
  // paper: {
  //   padding: theme.spacing(3),
  // },
  formControl: {
    width: '100%',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
    width: '100%',
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  item: {
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    padding: '10px',
    height: '100%',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
  },
  popover: {
    width: 600,
  },
  box: {
    maxWidth: 700,
    maxHeight: '100vh',
    minHeight: '50px',
    overflow: 'auto',
    margin: '15px auto',
    padding: '10px',
    borderRadius: 4,
    backgroundColor: theme.palette.primary.light,
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  paper: {
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(
      3
    )}px`,
  },
  filterIcon: {
    marginRight: '20px',
  },
  window: {
    height: '100vh',
  },
  margin: {
    marginTop: theme.spacing(3),
  },
  marginTop: {
    marginTop: theme.spacing(1),
  },
  gridAreas: {
    marginBottom: theme.spacing(2),
  },
  select: {
    marginTop: theme.spacing(2),
  },
  blue: {
    backgroundColor: 'blue',
  },
  textAreaMargin: {
    marginTop: '25px',
  },
  centerButton: {
    display: 'flex',
    justifyContent: 'center',
  },
  inputWidth: {
    width: '100%',
  },
  tableRow: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  tableStyle: {
    backgroundColor: theme.gray2Color,
  },
  skeleton: {
    width: '100%',
    backgroundColor: theme.palette.secondary.light,
    height: '100%',
  },
  btnRefreshing: {
    animationName: '$circle',
    animationDuration: '1.3s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
  },
  amanha: { color: '#3f51b5', borderColor: '#3f51b5', width: '100%' },
  hoje: { color: '#4caf50', borderColor: '#4caf50', width: '100%' },
  finalizado: { color: '#4caf50', borderColor: '#4caf50', width: '100%' },
  cancelado: { color: '#f3c623', borderColor: '#f3c623', width: '100%' },
  other: { color: '#f44336', borderColor: '#f44336', width: '100%' },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  btnRefresh: {},
  tableRowMov: {
    textDecoration: 'none',
    '&:hover': {
      cursor: 'pointer',
      transform: 'scale(1.008)',
      transitionDuration: '0.2s',
    },
  },
  rowCanCatch: {
    backgroundColor: '#e8eaf6',
    borderLeft: '10px solid',
    borderLeftColor: '#00a8ff',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  dropzone: {
    backgroundColor: 'rgba(204, 204, 204, .5)',
    border: 'none',
    minHeight: '140px',
  },
  listTimeModal: {
    fontWeight: 'bold',
    fontSize: '1.1em',
  },
  rowLate: {
    backgroundColor: '#ffebee',
    borderLeft: '10px solid',
    borderLeftColor: '#e84118',
  },
  buttonDanger: {
    color: theme.palette.danger.main,
    borderColor: theme.palette.danger.light,
    marginRight: theme.spacing(3),
  },
  listContainer: {
    padding: '15px',
    background: '#eee',
  },
  listStyles: {
    listStyle: 'none',
    padding: 0,
  },
  listContainerTitle: {
    fontWeight: 'bold',
    fontSize: '1.2em',
  },
  listContainerTotal: {
    fontSize: '1.1em',
  },
  appointments: {
    backgroundColor: '#eee',
    maxHeight: '200px',
    overflow: 'auto',
  },
  totalTableRoot: {
    overflow: 'hidden',
  },
  '@keyframes enter': {
    from: { opacity: 0, transform: 'translateX(-35%)' },
    to: { opacity: 1, transform: 'translateX(0%)' },
  },
  '@keyframes enterRight': {
    from: { opacity: 0, transform: 'translateX(35%)' },
    to: { opacity: 1, transform: 'translateX(0%)' },
  },
  '@keyframes enterY': {
    from: { opacity: 0, transform: 'translateY(-50%)' },
    to: { opacity: 1, transform: 'translateY(0%)' },
  },
  '@keyframes removeItem': {
    from: { opacity: 1, transform: 'translateY(0%)' },
    to: { opacity: 0, transform: 'translateY(50%)' },
  },
  financialCard: {
    animationTimingFunction: 'ease-in',
    '& > :nth-child(1)': {
      animation: '$enter',
      animationDuration: '500ms',
    },
    '& > :nth-child(2)': {
      animation: '$enter',
      animationDuration: '500ms',
      animationDelay: '200ms',
      animationFillMode: 'backwards',
    },
    '& > :nth-child(3)': {
      animation: '$enter',
      animationDuration: '500ms',
      animationDelay: '400ms',
      animationFillMode: 'backwards',
    },
    '& > :nth-child(4)': {
      animation: '$enter',
      animationDuration: '500ms',
      animationDelay: '600ms',
      animationFillMode: 'backwards',
    },
  },
  laundryOsCard: {
    animationTimingFunction: 'ease-in',
    '& > :nth-child(1)': {
      animation: '$enterY',
      animationDuration: '500ms',
    },
    '& > :nth-child(2)': {
      animation: '$enterY',
      animationDuration: '500ms',
      animationDelay: '200ms',
      animationFillMode: 'backwards',
    },
    '& > :nth-child(3)': {
      animation: '$enterY',
      animationDuration: '500ms',
      animationDelay: '400ms',
      animationFillMode: 'backwards',
    },
  },
  calendarContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',

    height: 'calc(100vh - 220px)',
  },
  calendarHeader: {
    width: '100%',
    height: 'auto',
    maxHeight: '100px',
  },
  calendar: {
    flex: 1,
    // height: '100%',
    height: 'calc(100vh - 270px)',
  },
  calendarButtons: {
    width: '80px',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'row',
    '& > :first-child': {
      borderRadius: '5px 0 0 5px',
    },
    '& > :last-child': {
      borderRadius: '0 5px 5px 0',
    },
  },
  calendarButton: {
    width: '50%',
    borderRadius: '0',
    border: `1px solid ${colors.graylight}`,
    padding: 0,
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: 'inherit',
      opacity: '0.5',
    },
  },
  todayButton: {
    width: 'auto',
    height: '100%',
    padding: '0 12px',
    fontSize: '14px',
    borderRadius: '5px',
    border: `1px solid ${colors.graylight}`,
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: 'inherit',
      opacity: '0.5',
    },
  },
  calendarHeaderTitle: {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '16px',
    textAlign: 'center',
    color: colors.primary,
    textTransform: 'capitalize',
  },
  periodButtons: {
    width: '157px',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    '& > :first-child': {
      borderRadius: '5px 0 0 5px',
    },
    '& > :last-child': {
      borderRadius: '0 5px 5px 0',
    },
  },
  periodButton: {
    borderRadius: '0',
    height: '22px',
    fontSize: '14px',
    color: colors.gray,
    textTransform: 'capitalize',
    fontWeight: '400',
    border: `1px solid ${colors.graylight}`,
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: 'inherit',
      opacity: '0.8',
    },
  },
  active: {
    backgroundColor: colors.primary,
    color: '#FFF',
    '&:hover': {
      backgroundColor: `${colors.primary} !important`,
      opacity: '0.8',
    },
  },
  calendarBody: {
    height: `calc(100vh - 365px)`,
    overflowY: 'auto',
  },
  chipdsDefaultPannel: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  chipdsDefaultPannelExpanded: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  ehadingChips: {
    fontSize: theme.typography.pxToRem(15),
  },
  chevronIcon: {
    position: 'absolute',
    marginLeft: '12px',
    animation: '$arrow',
    animationDuration: '650ms',
    animationTimingFunction: 'ease',
    animationIterationCount: 'infinite',
    animationDirection: 'alternate',
  },
  '@keyframes arrow': {
    to: {
      transform: 'translateX(-8px)',
    },
  },
  laundryTechniciansContainer: {
    margin: '20px 0px',
    // border: '1px solid #ccc',
    padding: '15px',
    // borderRadius: '10px',
  },
  attendanceRowLeft: {
    animation: '$enter',
    animationDuration: '500ms',
  },
  attendanceRowRight: {
    animation: '$enterRight',
    animationDuration: '500ms',
  },
  removeAttendanceLine: {
    animation: '$removeItem',
    animationDuration: '500ms',
  },
  hoverRestoration: {
    backgroundColor: theme.palette.primary.light,
    transition: 'background-color 0.3s linear',
  },
  calendarEventsContainer: {
    height: 'calc(100vh - 180px)',
    // width: '100%',
    // overflowY: 'auto',
    // '&::-webkit-scrollbar': {
    //   width: '3px',
    //   height: '4px',
    //   backgroundColor: colors.graylight,
    // },
    // '&::-webkit-scrollbar-thumb': {
    //   background: colors.secondary,
    //   height: '4px',
    // },
  },
  tableStickHeader: {
    maxHeight: 'calc(100vh - 252px)',
  },
  calendarBookModalArrows: {
    cursor: 'pointer',
  },
  formasPagamentoContainer: {
    padding: theme.spacing(2),
    margin: `${theme.spacing(2)}px 0px`,
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
  filterAttendances: {
    maxHeight: 'calc(100vh - 420px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: '2px',
      height: '8px',
      backgroundColor: colors.graylight,
    },
    '&::-webkit-scrollbar-thumb': {
      background: colors.secondary,
    },
  },
  scroller: {
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: '3px',
      height: '8px',
      backgroundColor: colors.graylight,
    },
    '&::-webkit-scrollbar-thumb': {
      background: colors.secondary,
    },
  },
  periodBox: {
    borderLeft: `3px solid ${colors.secondary}`,
    backgroundColor: '#D9D9D933',
    fontSize: '12px',
    lineHeight: '15px',
    color: colors.gray,
    padding: '8px',
    width: '100%',
    maxHeight: '147px',
  },
  periodBoxItemTitle: {
    padding: '0 4px',
  },
  btnAdicionar: {
    height: '18px',
    width: '88px',
    color: '#FFF',
    backgroundColor: colors.primary,
    borderRadius: '15px',
    fontSize: '12px',
    textAlign: 'center',
  },
  servicesBox: {
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 500px)',
  },
  input: {
    padding: '4px',
    borderBottom: `2px solid${colors.graylight}`,
  },
  paperEvents: {
    // visibility: 'hidden',
    maxHeight: 'calc(100vh - 200px)',
    padding: '0 4px',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '20px',
    '&::-webkit-scrollbar': {
      width: '4px',
      height: '4px',
      backgroundColor: colors.graylight,
    },
    '&::-webkit-scrollbar-thumb': {
      background: colors.secondary,
      height: '4px',
    },
  },
  event: {
    width: '260px',
    borderRadius: '10px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      boxShadow: '0px 4px 4px 0px #00000040',
    },
    border: '1px solid red',
  },
})
